import { useState } from 'react';
import { Maximize } from 'iconsax-react';

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@src/design-system/popover';
import { FiltersPopoverContent } from './filter-popover-content/filter-popover-content';
import { FilterModal } from './filter-modal';

export function FilterBtnPopover({
  FilterBtn,
}: {
  FilterBtn: () => JSX.Element;
}) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleExpand = () => {
    setIsPopoverOpen(false);
    setIsModalOpen(true);
  };

  const handleMinimize = () => {
    setIsModalOpen(false);
    setIsPopoverOpen(true);
  };

  return (
    <>
      <Popover
        open={isPopoverOpen}
        onOpenChange={setIsPopoverOpen}
      >
        <PopoverTrigger asChild>
          <div>
            <FilterBtn />
          </div>
        </PopoverTrigger>

        <PopoverContent
          align='end'
          alignOffset={-114}
          className='relative w-[416px] overflow-visible! p-0 shadow-lg'
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          <button
            type='button'
            onClick={handleExpand}
            aria-label='Expand filters'
            className='absolute -top-4 -right-4 z-10 flex size-8 items-center justify-center rounded-lg border border-primary-200 bg-white text-primary-1000 shadow-sm transition-colors hover:bg-primary-50'
          >
            <Maximize size={16} />
          </button>

          <div className='max-h-[300px] overflow-auto p-4 [&::-webkit-scrollbar]:hidden'>
            <FiltersPopoverContent />
          </div>
        </PopoverContent>
      </Popover>

      <FilterModal
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
        onMinimize={handleMinimize}
      />
    </>
  );
}
